// utils
import ModelMapperApi from '@utils/modelMapperApi.compose'

// services
import { WorkOrdersService } from '@/services/notifications'

// models
import OnHoldNotificationsModel from '@/models/notifications/onHold'

// mappers
import { mapOnHoldNotificationsFromApi } from '@/mappers/notifications/onHold'

// enums

// strings

export default {
  namespaced: true,
  state: {
    onHoldNotifications: new OnHoldNotificationsModel()
  },
  mutations: {
    setOnHoldNotifications (state, onHoldNotifications) {
      state.onHoldNotifications = onHoldNotifications
    }
  },
  actions: {
    async fetchOnHoldOrderNotifications ({ commit, dispatch }) {
      let onHoldOrderNotifications
      const getOnHoldOrderNotificationsFunc = ModelMapperApi.get(
        ModelMapperApi.model(OnHoldNotificationsModel),
        ModelMapperApi.mapper(mapOnHoldNotificationsFromApi),
        ModelMapperApi.service(WorkOrdersService.fetchOnHoldReasons, WorkOrdersService)
      )
      try {
        onHoldOrderNotifications = await getOnHoldOrderNotificationsFunc()
      } catch (ex) {
        onHoldOrderNotifications = new OnHoldNotificationsModel()
      }
      commit('setOnHoldNotifications', onHoldOrderNotifications)
    }
  },
  getters: {
    onHoldNotifications: state => state.onHoldNotifications
  }
}
